import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { useComponentIdentitySupport, renderChildrenWithIdentity } from "abreact/core/pagestate/PageStateApi";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import * as React from "react";

/**
 * The properties that can be specified when constructing an HBox or VBox.
 */

export class LayoutUtils {
  static renderBox(className, props) {
    // we don't want users to be able to directly import and render an <AbBox, so keep this in a class method and turn
    // off the lint rule
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const componentIdentitySupport = useComponentIdentitySupport(props, className);
    return /*#__PURE__*/React.createElement("div", _extends({}, ReactUtils.componentProps(className, props, [props.spacing && "ab-box-spacing", props.divideSpaceEqually && "ab-box-divide-space-equally", props.wrapChildren && "ab-wrapping-box"]), props.eventHandlers, {
      ref: props.abRef
    }), renderChildrenWithIdentity(componentIdentitySupport, props));
  }
}
//# sourceMappingURL=LayoutUtils.js.map
